export const REMOTE_DC_DEFAULT_SIMILARITY_THRESHOLD_PCT = 90;
export const REMOTE_DC_DEFAULT_DELTA_THRESHOLD_PCT = 4;
export const REMOTE_DC_DEFAULT_SSM_CONFIDENCE_THRESHOLD_PCT = 60;
export const REMOTE_DC_DEFAULT_SEARCH_SIZE = 500;
export const REMOTE_DC_DEFAULT_SAMPLE_SIZE = 50;
export const REMOTE_DC_DEFAULT_MERGE_LINKED_CANDIDATES = true;
